<template>
  <div v-if="$screen.isMobile($mq)" class="action-sheet">
    <div v-show="visible" class="action-sheet__overlay" @click="$emit('close')" />
    <div v-show="visible" class="action-sheet__wrapper">
      <div class="action-sheet-header">
        <h5>{{title}}</h5>
        <dd-button
          size="small"
          type="circle"
          class="action-sheet-header__close-button"
          @click="$emit('close')"
        >
          <i class="ddi ddi-close" />
        </dd-button>
      </div>
      <div class="action-sheet-body">
        <slot name="list" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ActionSheet',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Options',
    },
  },

  emits: ['close'],
  watch: {
    visible(val: boolean) {
      if (!this.$screen.isMobile(this.$mq)) {
        return
      }
      val === true ? this.$bodyScroll.disable() : this.$bodyScroll.enable()
    },
  },
  beforeUnmount() {
    if (this.$screen.isMobile(this.$mq)) {
      this.$bodyScroll.enable()
    }
  },
})
</script>

<style lang="scss">
.action-sheet {
  position: absolute;
  z-index: 2000;

  &__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1998;
    background: $color--gray-90;
    opacity: 0.9;
  }

  &__wrapper {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1999;
    display: flex;
    flex-direction: column;
    height: auto;
    max-height: 400px;
    background: var(--color-background-header);
    border-radius: 8px 8px 0 0;

    .action-sheet-header {
      display: flex;
      align-items: center;
      margin: 0 12px;
      min-height: 48px;

      &__close-button {
        position: relative;
        z-index: 1032;
        margin-left: auto;

        &::before {
          box-shadow: none;
        }
      }
    }

    .action-sheet-header__close-button.dd-button.dd-button--small {
      width: 24px;
      height: 24px;
      font-size: 10px;
      color: $slate;
    }

    .action-sheet-body {
      padding: 0 12px;
      overflow-y: auto;
    }
  }
}
</style>
